import { Injectable, inject } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { UntypedFormGroup, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { DNIAlreadyExistsValidator, DNIMediadorValidator } from '../Common/validators-dni';
import { RemoteCallCommonService, ICallParams } from './remote-call-common.service';

export interface IColegiadoRecord {

    dni_colegiado: string | null;
    nombre_colegiado: string;
    numero_colegiado: string;
}

@Injectable({
    providedIn: 'root'
})
export class ColegiadosService {
    private _RemoteCallCommonS: RemoteCallCommonService = inject(RemoteCallCommonService);

    // private _current_info:IRemoteRecordFormat | null = null;
    private _record = this.getEmptyPersonaRecord();

    // ===========================================================================
    // ---------------------------------------------------------------------------
    public getEmptyRecord(): IColegiadoRecord {

        return Object.assign({}, {
            dni_colegiado: null,
            nombre_colegiado: '',
            numero_colegiado: ''
        });

    }

    // ---------------------------------------------------------------------------
    public getEmptyPersonaRecord(): any {
        return {
            dni: '',
            nombre: '',
            apellido1: '',
            apellido2: '',
            empresa: '',
            tipo_empresa: '',
            cargo: '',
            direccion: '',
            codigo_postal: '',
            ciudad: '',
            pais: '',
            telefono: '',
            email: '',
            empresa_invitacion: '',
            acto_social: 0
        };
    }

    // ---------------------------------------------------------------------------
    public existeDNI(dni: string) {
        const self = this;

        return new Observable<any>((observer: Observer<any>) => {
            const call_params: ICallParams = {
                class: 'colegiados',
                accion: 'existeDato',
                filtro: "dni = '" + dni + "'"
            };
            self._RemoteCallCommonS.sendJSONPost(call_params).subscribe(
                (r: any) => {
                    if (!r.error.codigo) {
                        observer.next(r.datos)
                    }
                },
                (e) => observer.error(e)
            );
        });
    }

    // ---------------------------------------------------------------------------
    public esColegiado(dni: string): Observable<boolean> {
        const self = this;

        return new Observable<any>((observer: Observer<boolean>) => {
            const call_params: ICallParams = {
                class: 'Colegiados',
                accion: 'esMediadorColegiadoJSON',
                params: JSON.stringify({ dni: dni })
            };
            self._RemoteCallCommonS.sendJSONPost(call_params).subscribe(
                (r: any) => {
                    if (!r.error.codigo) {
                        observer.next(r.datos.es_mediador);
                    } else {
                        observer.next(false);
                    }
                },
                (e) => observer.error(e)
            );
        });
    }

    public esMediador = this.esColegiado;


}
